// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"20db53f2","220":"03c12500","431":"a472ecf2","489":"e24a9c7a","507":"8de45059","608":"c304d4e8"}[chunkId] + ".chunk.js";
};